import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class RateTableListItem extends SearchModelBase {
    id: number = 0;
    effectETD: string | null = null;
    fromEffectETD: string | null = null;
    toEffectETD: string | null = null;
    expireETD: string | null = null;
    fromExpireETD: string | null = null;
    toExpireETD: string | null = null;
    mode: string = '';
    origin: string = '';
    destination: string = '';
    doorBy: string = '';
    carrier: string = '';
    size: string = '';
    commodity: string = '';
    rate1: number = 0;
    fromRate1: number|null = null;
    toRate1: number|null = null;
    rate2: number = 0;
    fromRate2: number|null = null;
    toRate2: number|null = null;
    transit: number = 0;
    fromTransit: number|null = null;
    toTransit: number|null = null;
    remark: string = '';
    company: string = '';
    tBId: number = 0;
    tBName: string = '';
    tBType: string = '';
    
    sName: string = ''//Cloud Only

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Effect ETD', width: 90, dataIndex: 'effectETD', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 1, text: 'Expire ETD', width: 90, dataIndex: 'expireETD', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 2, text: 'Mode', width: 250, dataIndex: 'mode' }),
        XCol.Create({ col: 3, text: 'Origin', width: 300, dataIndex: 'origin' }),
        XCol.Create({ col: 4, text: 'Destination', width: 40, dataIndex: 'destination' }),
        XCol.Create({ col: 5, text: 'Door By', width: 50, dataIndex: 'doorBy' }),
        XCol.Create({ col: 6, text: 'Commodity', width: 50, dataIndex: 'commodity' }),
        XCol.Create({ col: 7, text: 'Carrier', width: 50, dataIndex: 'carrier' }),
        XCol.Create({ col: 8, text: 'Type', width: 50, dataIndex: 'size' }),
        XCol.Create({ col: 9, text: 'Rate1', width: 60, dataIndex: 'rate1', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 10, text: 'Rate2', width: 60, dataIndex: 'rate2', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 11, text: 'Transit', width: 60, dataIndex: 'transit', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 12, text: 'Remark', width: 50, dataIndex: 'remark' }),
        XCol.Create({ col: 13, text: 'Company', width: 50, dataIndex: 'company' }),

    ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: RateTableListItem.prototype.effectETD, orderByAscending: true };

    public static formatData(data: RateTableListItem[]) {
        return data.map((d: RateTableListItem) => ({
          ...d,
        }));
    }
    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        expireETD: {from: 'fromExpireETD', to: 'toExpireETD'},
        effectETD: {from: 'fromEffectETD', to: 'toEffectETD'},
        rate1: {from: 'fromRate1', to: 'toRate1'},
        rate2: {from: 'fromRate2', to: 'toRate2'},
        transit: {from: 'fromTransit', to: 'toTransit'},
    }
}
